import * as React from "react";
import styles from "./app-input.module.css";
import {cn} from "@/lib/utils";

interface AppInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    isError?: boolean;
    as?: React.ElementType;
    options?: any;
}

export const AppInput = ({isError, className, as, ...props}: AppInputProps) => {
    const Component = as || 'input';
    return (
        <Component
            className={
                cn(
                    'bg-dark-gray border border-stroke-gray text-white placeholder-light-gray font-medium w-full h-[48px] py-[15px] px-[16px] rounded-[6px]',
                    {[styles.InputError]: isError},
                    className,
                )
            }
            {...props}
        />
    );
}
